import { BaseViewStore } from 'core/stores';
import { FacilityOrderTemplateItemService } from "application/facility-order/services";
import { action, observable } from "mobx";
import { LookupService } from "common/services"
import React from 'react';
import { ModalParams } from 'core/models';

class FacilityOrderTemplateItemNewFlowCalculationModalStore extends BaseViewStore {
    @observable accessor isEnteredTotalWrong = false;
    @observable accessor tempValues = {};
    @observable accessor isRecalculateDisabled = false;
    @observable accessor facilityOrderTemplateItem = null;
    @observable accessor facilityOrderTemplateItemRef = null;
    @observable accessor isTab = false;
    @observable accessor isSavingResource = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.item = componentProps.modalParams.data.facilityOrderTemplateItem;
        this.facilityOrderTemplateItem = { ...this.item, mlph: 0, frequency: 0, itemMls: 0, itemCals: 0 };

        if (this.item.note) {
            this.getNoteQuantity(/(\d*(?:\.\d*)?)(.ml\*)/, "mlph")
            this.getNoteQuantity(/(\d*(?:\.\d*)?)(.hrs|.=)/, "frequency");
            this.getNoteQuantity(/(\d*(?:\.\d*)?)(.ml|.can|.cans|.lps)(?!\*)/, "itemMls");
            this.getNoteQuantity(/\d*(?:[.,]?\d*)?(?=\s*[kK]?[cC]al)/, "itemCals");
        }

        this.facilityOrderTemplateItemRef = {
            mlph: React.createRef(),
            frequency: React.createRef(),
            itemMls: React.createRef(),
            itemCals: React.createRef()
        };

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplate = this.modalParams.data.facilityOrderTemplate;
        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.isUpdate = this.modalParams.data.isUpdate;
        this.showTemplateChangeWarning = this.modalParams.data.showTemplateChangeWarning;
        this.showWarningModal = this.modalParams.data.showWarningModal;
        this.changeFacilityOrderTemplateStatus = this.modalParams.data.changeFacilityOrderTemplateStatus;
        this.isUSIntakeNewFlow = this.modalParams.data.isUSIntakeNewFlow;
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(this.rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);
        this.setTempValues();

        this.calculationConfirmModal = new ModalParams({ onClose: null });
        this.calculationConfirmModal.onConfirm = async () => { await this.updateFacilityOrderTemplate(); this.calculationConfirmModal.close(); };
        this.calculationConfirmModal.onCancel = () => { this.calculationConfirmModal.close() };
        this.fetch([this.initialize()]);
    }

    @action
    async initialize() {
        await this.showWarningMessage("");
        this.setIsRecalculateDisabled();
    }

    @action.bound
    setIsRecalculateDisabled() {
        let arry = [this.facilityOrderTemplateItem.itemCals, this.facilityOrderTemplateItem.itemMls, this.facilityOrderTemplateItem.mlph, this.facilityOrderTemplateItem.frequency]
        this.isRecalculateDisabled = arry.filter(i => i === "").length > 2 || (this.facilityOrderTemplateItem.mlph === "" && this.facilityOrderTemplateItem.frequency === "");
    }

    @action
    getNoteQuantity(regex, propertyName) {
        let match = this.item.note.toLowerCase().match(regex);
        if (match && match[0] && parseFloat(match[0])) {
            this.facilityOrderTemplateItem[propertyName] = parseFloat(match[0]);
        }
    }

    @action.bound
    editItem(value, name, propertyName) {
        const number = parseFloat(value);
        if(isNaN(number) && value != "")
            return;

        let roundedString = value;
        if (!isNaN(number) && !roundedString.endsWith(".")) {
            const roundedNumber = Math.floor(number * 10) / 10;
            roundedString = roundedNumber.toString();
        }

        this.facilityOrderTemplateItem[name] = roundedString;
        this.setIsRecalculateDisabled();
        this.selectedField = { name: name, propertyName: propertyName };
    }

    @action.bound
    async calculateQuantity(propertyName, name, selected) {
        if (parseFloat(this.tempValues[name]) === parseFloat(this.facilityOrderTemplateItem[name])) {
            return;
        }

        if (this.facilityOrderTemplateItem[name] === "") {
            this.tempValues[name] = "";
            this.isEnteredTotalWrong = false;
            return;
        }

        if (this.facilityOrderTemplateItem[name] != this.tempValues[name] || propertyName === "itemMlph" || propertyName === "itemFrequency") {
            await this.showWarningMessage(propertyName);
            if (!this.isEnteredTotalWrong) {
                var response = await this.facilityOrderTemplateItemService.calculateQuantityNewFlow({
                    facilityOrderId: this.facilityOrderId,
                    productId: this.facilityOrderTemplateItem.productId,
                    facilityOrderTemplateId: this.facilityOrderTemplateItem.facilityOrderTemplateId,
                    orderQuantity: 0,
                    templateQuantity: this.facilityOrderTemplateItem.templateQuantity,
                    itemCals: this.facilityOrderTemplateItem.itemCals ? this.facilityOrderTemplateItem.itemCals : 0,
                    itemMls: this.facilityOrderTemplateItem.itemMls ? this.facilityOrderTemplateItem.itemMls : 0,
                    itemMlph: this.facilityOrderTemplateItem.mlph ? this.facilityOrderTemplateItem.mlph : 0,
                    frequency: this.facilityOrderTemplateItem.frequency ? this.facilityOrderTemplateItem.frequency : 0,
                    changedValue: propertyName
                });

                this.facilityOrderTemplateItem.templateQuantity = response.templateQuantity;
                this.facilityOrderTemplateItem.itemCals = response.itemCals;
                this.facilityOrderTemplateItem.itemMls = response.itemMls;
                this.facilityOrderTemplateItem.mlph = response.mlph;
                this.facilityOrderTemplateItem.frequency = response.frequency;
            }
            this.setTempValues();
        }

        if (this.isTab && selected) {
            this.facilityOrderTemplateItemRef[selected].current.focus();
            this.facilityOrderTemplateItemRef[selected].current.select();
        }
        this.isTab = false;
    }

    @action.bound
    async recalculateQuantity() {
        var hasAllData = !!this.facilityOrderTemplateItem.itemCals && !!this.facilityOrderTemplateItem.itemMls && !!this.facilityOrderTemplateItem.mlph && !!this.facilityOrderTemplateItem.frequency;
        try {
            var response = await this.facilityOrderTemplateItemService.recalculateQuantityNewFlow({
                facilityOrderId: this.facilityOrderId,
                productId: this.facilityOrderTemplateItem.productId,
                orderQuantity: 0,
                templateQuantity: this.facilityOrderTemplateItem.templateQuantity,
                itemCals: !hasAllData && this.facilityOrderTemplateItem.itemCals ? this.facilityOrderTemplateItem.itemCals : null,
                itemMls: !hasAllData && this.facilityOrderTemplateItem.itemMls ? this.facilityOrderTemplateItem.itemMls : null,
                itemMlph: this.facilityOrderTemplateItem.mlph ? this.facilityOrderTemplateItem.mlph : null,
                frequency: this.facilityOrderTemplateItem.frequency ? this.facilityOrderTemplateItem.frequency : null
            });
        }
        catch (err) {
            return;
        }

        this.facilityOrderTemplateItem.templateQuantity = response.templateQuantity;
        this.facilityOrderTemplateItem.itemCals = response.itemCals;
        this.facilityOrderTemplateItem.itemMls = response.itemMls;
        this.facilityOrderTemplateItem.mlph = response.mlph;
        this.facilityOrderTemplateItem.frequency = response.frequency;

        this.isEnteredTotalWrong = false;
        this.setTempValues();
    }

    @action.bound
    async updateResource() {
        try {
            this.isSavingResource = true;
            if (this.facilityOrderTemplateItem.itemMls === "" || this.facilityOrderTemplateItem.itemCals === "" || this.facilityOrderTemplateItem.itemMls == 0 || this.facilityOrderTemplateItem.itemCals == 0) {
                this.isEnteredTotalWrong = true;
                this.isSavingResource = false;
                this.errorMessage = "Some information is missing, please review and recalculate.";
                return;
            }

            if (this.isEnteredTotalWrong) {
                this.calculationConfirmModal.open({
                    message: "Entered values contradict each other. Are you sure you want to save the changes?"
                });
            }
            else {
                if (!this.selectedField) {
                    this.selectedField = { name: "itemCals", propertyName: "itemCals" };
                }
                await this.calculateQuantity(this.selectedField.propertyName, this.selectedField.name, null);
                await this.updateFacilityOrderTemplate();
            }
            this.isSavingResource = false;
        }
        catch (err) {
            this.isSavingResource = false;
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async updateFacilityOrderTemplate() {
        if(this.facilityOrderTemplateItem.templateQuantity < this.item.sendSeparatelyQty){
            this.rootStore.notificationStore.error("An SS has already been applied to this item. The sales order qty cannot be lower than the SS qty.");
            return;
        }

        this.lookups = await this.lookupService.getLookups("ImportAction,ItemType");
        const oldTemplateQty = this.item.templateQuantity;
        const oldItemCals = this.item.itemCals;
        const oldItemMls = this.item.itemMls;
        const oldItemFrequency = this.item.frequency;
        if (this.showTemplateChangeWarning && this.showWarningModal && this.item.templateQuantity != this.facilityOrderTemplateItem.templateQuantity) {
            this.showTemplateChangeWarning();
        }

        this.item.templateQuantity = this.facilityOrderTemplateItem.templateQuantity;
        this.item.orderQuantity = this.facilityOrderTemplateItem.templateQuantity;
        this.item.mlph = this.facilityOrderTemplateItem.mlph;
        this.item.frequency = this.facilityOrderTemplateItem.frequency;
        this.item.itemMls = this.facilityOrderTemplateItem.itemMls;
        this.item.itemCals = this.facilityOrderTemplateItem.itemCals;
        let hrs = (this.facilityOrderTemplateItem.product.itemTypeId == this.lookups.itemType.find(x => x.abrv === "can").id || (this.facilityOrderTemplateItem.product.procedureCode_ && this.facilityOrderTemplateItem.product.procedureCode_.abrv === "B4155")) ? '' : 'hrs';
        this.item.note = this.item.mlph === 0 && this.item.frequency === 0 ? this.item.itemMls + 'ml-' + this.item.itemCals + 'kcals' : this.item.mlph + 'ml*' + this.item.frequency + `${hrs}=` + this.item.itemMls + 'ml-' + this.item.itemCals + 'kcals';

        this.addVisualCueToChanges();

        if (this.isUpdate) {
            const importActionDelete = this.lookups.importAction.find(x => x.abrv === 'delete');
            if (this.item.templateItemId && this.item.importActionId != importActionDelete.id) {

                this.item.importAction = this.lookups.importAction.find(x => x.abrv === "update");
                this.item.importActionId = this.item.importAction.id;
            }

            if(this.isUSIntakeNewFlow){
                await this.facilityOrderTemplateItemService.newFlowUpdate(this.item);
                this.facilityOrderTemplate.isDifferentQty = (this.facilityOrderTemplate.clinicalStatus.name == "Covered" || this.facilityOrderTemplate.clinicalStatus.name == "Prior Auth Obtained") && this.facilityOrderTemplate.facilityOrderTemplateItems.some(x=> x.templateQuantity != x.orderQuantity);
                if (this.changeFacilityOrderTemplateStatus && 
                    (this.item.templateQuantity != oldTemplateQty || 
                    this.item.itemCals != oldItemCals || 
                    (this.item.itemMls != oldItemMls && (oldItemMls != null && oldItemMls != 0)) ||
                    (this.item.frequency != oldItemFrequency && (oldItemFrequency != null && oldItemFrequency != 0)))) {
                        this.changeFacilityOrderTemplateStatus();
                }
            }
            else{
                let result = await this.facilityOrderTemplateItemService.newUpdate(this.item);
                if (result) {
                    this.item.orderQuantity = result.orderQuantity;
                    this.item.templateQuantity = result.templateQuantity;

                    this.item.importActionId = result.importActionId;
                    const importAction = this.lookups.importAction.find(x => x.id === this.item.importActionId);
                    this.item.importAction = importAction;

                    this.facilityOrderTemplate.isDifferentQty = result.isDifferentQty;

                    if (this.changeFacilityOrderTemplateStatus && 
                        (this.item.templateQuantity != oldTemplateQty || 
                        this.item.itemCals != oldItemCals || 
                        (this.item.itemMls != oldItemMls && (oldItemMls != null && oldItemMls != 0)) ||
                        (this.item.frequency != oldItemFrequency && (oldItemFrequency != null && oldItemFrequency != 0)))) {
                            this.changeFacilityOrderTemplateStatus();
                    }
                }
            }
        }
        this.modalParams.close();
    }

    @action.bound
    async showWarningMessage(propertyName) {
        if (this.facilityOrderTemplateItem.itemMls === "" || this.facilityOrderTemplateItem.itemCals === "" || this.facilityOrderTemplateItem.mlph === "" || this.facilityOrderTemplateItem.frequency === ""
            || this.facilityOrderTemplateItem.itemMls == 0 || this.facilityOrderTemplateItem.itemCals == 0 || this.facilityOrderTemplateItem.mlph == 0 || this.facilityOrderTemplateItem.frequency == 0) {
            return;
        }

        var recalculatedQuantity = await this.getRecalculatedQuantity();
        if (((propertyName == "" || propertyName === "itemMls") && this.facilityOrderTemplateItem.itemMls != recalculatedQuantity.itemMls) ||
            ((propertyName == "" || propertyName === "itemCals") && this.facilityOrderTemplateItem.itemCals != recalculatedQuantity.itemCals)) {
            this.errorMessage = "Entered values contradict each other.";
            this.isEnteredTotalWrong = true;
        }
        else {
            this.isEnteredTotalWrong = false;
        }
    }

    @action.bound
    setTempValues() {
        this.tempValues["mlph"] = this.facilityOrderTemplateItem.mlph;
        this.tempValues["frequency"] = this.facilityOrderTemplateItem.frequency;
        this.tempValues["itemMls"] = this.facilityOrderTemplateItem.itemMls;
        this.tempValues["itemCals"] = this.facilityOrderTemplateItem.itemCals;
    }

    @action.bound
    async getRecalculatedQuantity() {
        try {
            var response = await this.facilityOrderTemplateItemService.recalculateQuantityNewFlow({
                facilityOrderId: this.facilityOrderId,
                productId: this.facilityOrderTemplateItem.productId,
                orderQuantity: 0,
                templateQuantity: this.facilityOrderTemplateItem.templateQuantity,
                itemMlph: this.facilityOrderTemplateItem.mlph ? this.facilityOrderTemplateItem.mlph : null,
                frequency: this.facilityOrderTemplateItem.frequency ? this.facilityOrderTemplateItem.frequency : null
            });
            return response;
        }
        catch (err) {
            return;
        }
    }

    @action.bound
    handleKeyDown(event) {
        if (event.key === 'Tab') {
            this.isTab = true;
        }
    }

    addVisualCueToChanges() {
        if (this.item.facilityOrderTemplateItemInitial && this.item.templateQuantity != this.item.facilityOrderTemplateItemInitial.templateQuantity)
            this.item.isTemplateQuantityChanged = true;
        else
            this.item.isTemplateQuantityChanged = false;

        if (this.item.facilityOrderTemplateItemInitial && this.item.note != this.item.facilityOrderTemplateItemInitial.note)
            this.item.isNoteChanged = true;
        else
            this.item.isNoteChanged = false;
    }
}

export default FacilityOrderTemplateItemNewFlowCalculationModalStore;
